/**
 * Not Found Page (404)
 */

import React from 'react';
import { Link } from 'react-router-dom';

export function NotFoundPage() {
  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center p-4">
      <div className="text-center">
        <h1 className="text-5xl sm:text-6xl font-bold text-gray-900 mb-4">404</h1>
        <p className="text-xl sm:text-2xl font-semibold text-gray-700 mb-4">Page Not Found</p>
        <p className="text-gray-600 mb-8 break-words">Sorry, the page you're looking for doesn't exist.</p>
        <Link
          to="/"
          className="inline-block bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2.5 sm:py-2 px-6 rounded-md transition duration-200 min-h-[44px] sm:min-h-0"
        >
          Go to Dashboard
        </Link>
      </div>
    </div>
  );
}
